/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteOrganizationResponse } from '../../models/delete-organization-response';

export interface DeleteOrganization$Params {
  organizationId: string;
}

export function deleteOrganization(http: HttpClient, rootUrl: string, params: DeleteOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrganizationResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteOrganization.PATH, 'delete');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteOrganizationResponse>;
    })
  );
}

deleteOrganization.PATH = '/api/v2/{organizationId}';
